import { render, staticRenderFns } from "./agriServiceShop.vue?vue&type=template&id=a4f17618&scoped=true"
import script from "./agriServiceShop.vue?vue&type=script&lang=js"
export * from "./agriServiceShop.vue?vue&type=script&lang=js"
import style0 from "./agriServiceShop.vue?vue&type=style&index=0&id=a4f17618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f17618",
  null
  
)

export default component.exports